import { useLazyQuery } from "@apollo/client/react";
import { Grid } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { GET_DOCUMENTOS_BY_CODIGO_SAP, adaptDocumentosByCodigoSapArray } from '../../../data/graphQL/queries/GenerarMinuta/getDocumentosByCodigoSap';
import { GET_DOCUMENTOS_FAC, adaptDocumentoFacArray } from '../../../data/graphQL/queries/GenerarMinuta/getMinutaDocumentos';
import './generarMinutaGrilla.scss';


export const GenerarMinutaDetalleDocs = ({
  dataRegistro,
  disabledCheckbox,
  documentos,
  documentosSAP,
  documentosSeleccionados,
  setDocumentos,
  setDocumentosSAP,
  setDocumentosSeleccionados
}) => {
  const [documentosSeleccionadosOriginal, setDocumentosSeleccionadosOriginal] = useState([]);
  const [getDocumentos, { data: dataDocumentos, loading: documentosLoading }] = useLazyQuery(GET_DOCUMENTOS_FAC, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDocumentos) return;
    setDocumentos(adaptDocumentoFacArray(dataDocumentos.documentoFac));
    if (!documentosByCodigoSAPLoading) {
      getDocumentosByCodigoSAP({
        variables: {
          codigoSAP: dataRegistro.codClienteSAP,
          idPlanCuidado: dataRegistro.idPlanCuidado
        }
      });
    }
  }, [dataDocumentos]);

  const [getDocumentosByCodigoSAP, { data: dataDocumentosByCodigoSAP, loading: documentosByCodigoSAPLoading }] = useLazyQuery(GET_DOCUMENTOS_BY_CODIGO_SAP, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDocumentosByCodigoSAP) return;
    setDocumentosSAP(adaptDocumentosByCodigoSapArray(dataDocumentosByCodigoSAP.documentosByCodigoSap));
    // chequeo por default los documentos obligatorios
    let documentosDefault = [];
    dataDocumentosByCodigoSAP.documentosByCodigoSap.map((doc) => {
      documentosDefault.push({
        idDocumentoMinuta: doc.idDocumentoMinuta,
        descripcion: doc.descripcion
      });
    });
    setDocumentosSeleccionados(generateChecksByDefault(documentosDefault));
    setDocumentosSeleccionadosOriginal(generateChecksByDefault(documentosDefault));
  }, [dataDocumentosByCodigoSAP]);

  const generateChecksByDefault = (documentosDefault) => {
    let lista = [];
    documentos.map((doc, index) => {
      if (documentosDefault.filter((d) => d.idDocumentoMinuta == doc.idDocMinuta).length > 0) {
        lista.push(index + 1);
      }
    });
    return lista;
  };

  useEffect(() => {
    if (!documentosLoading)
      getDocumentos();
  }, []);

  const initialColumns = [
    {
      headerName: 'Documento',
      headerAlign: 'left',
      align: 'left',
      renderCell: (cellProps) => {
        const { row } = cellProps;
        const bold = documentosSAP.filter((d) => d.idDocumentoMinuta == row.idDocMinuta).length > 0 ? 800 : 400;
        return <div style={{ fontWeight: bold, paddingLeft: '20px' }}>
          {row.descripcion} {bold == 800 ? '*' : ''}
        </div>;
      }
    }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), [documentos, documentosSAP]);

  return (
    <>
      <Grid container spacing={1} sx={{ marginTop: '10px' }}>
        <Grid size={{ xs: 12, md: 12 }}>
          <div className='section-title'>Documentación Adjunta</div>
          <DataGridGenerico
            columns={columns}
            rows={documentos}
            toolbar={false}
            maxWidth={columns.reduce(
              (total, column) => total + (column.width || 0),
              0
            )}
            checkboxSelection
            isRowSelectable={(param) => !disabledCheckbox(param.row) && documentosSeleccionadosOriginal.includes(param.id)}
            onRowSelectionModelChange={(e) => setDocumentosSeleccionados(e)}
            loading={documentosLoading}
            rowSelectionModel={documentosSeleccionados} />

        </Grid>
      </Grid>
    </>);

};